module.exports = __webpack_public_path__ + "img/shiningStar.2f243c1b.svg";